
import { computed, defineComponent, onMounted, ref } from 'vue';
import PointInfo from '@/components/organisms/point/PointInfo.vue';
import CustomerCoupon from '@/components/organisms/coupon/CustomerCoupon.vue';
import SkeltonCoupon from '@/components/organisms/coupon/SkeltonCoupon.vue';
import { useCoupon } from '@/compositions/useCoupon';
import { CustomerCoupon as TypeCustomerCoupon } from '@/repositories/couponRepository';
import { i18n } from '@/plugins/i18n';

export default defineComponent({
  name: 'PointTransferExchange',

  components: {
    PointInfo,
    CustomerCoupon,
    SkeltonCoupon,
  },

  props: {
    pointTransfer: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    // Set title
    document.title = `${i18n.t('keyword.coupon')}交換済み${i18n.t('keyword.point')}`;

    const { getCustomerCouponDetail } = useCoupon();

    const customerCoupon = ref<TypeCustomerCoupon>();

    const customerCouponId = computed(() => {
      const target: { meta?: { customerCouponId: string } } = JSON.parse(props.pointTransfer.purpose).target;
      return target.meta?.customerCouponId || null;
    });

    onMounted(async () => {
      if (!customerCouponId.value) return;

      customerCoupon.value = await getCustomerCouponDetail(customerCouponId.value);
    });

    return {
      customerCoupon,
    };
  },
});
